<!-- version 2021/05/20 -->
<template>
    <app-header-title-text class="navbar-brand navbar-brand-center" :text="title"></app-header-title-text>
</template>

<script>
    import HeaderTitleText from './title-text.vue'

    export default {
        components: {
            appHeaderTitleText: HeaderTitleText
        },
        props: {
            title: String
        }
    }
</script>

<style lang="sass" scoped>
    span
        position: absolute
        top: 0
        left: 0
        text-align: center
        margin: 13px 0
        width: 100%
</style>